import DownloadButton from "../DownloadButton";
import { capitalizeFirstLetterOfEachWord } from "../../utils/Formatter";
import ProfilePlaceholder from "../../assets/svgIcons/ProfilePlaceholder.svg";
import "../../styles/components/transactionPrintLayouts/POInvoiceLayout.css";

export const DCInvoiceLayout = ({
  headDetails,
  companyData,
  itemDetails,
  rowData,
  invoiceTableData,
  selectedReportName,
}) => {
  const path = window.location.pathname.split("/").filter(Boolean);
  const transactionName = selectedReportName || path[1];

  const organizationData = JSON.parse(localStorage.getItem("organisation"));

  const formatDate = (dateStr) => {
    if (!dateStr) return "--";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const purchaseDetails = [
    { label: "D.C No", value: headDetails.tran_no },
    {
      label: "D.C Date",
      value: formatDate(headDetails.date || headDetails.created_at),
    },
  ];

  const formatCompanyAddress = (companyData) => {
    if (!companyData) return "N/A";

    const parts = [
      companyData.address?.trim(),
      companyData.city?.trim(),
    ].filter(Boolean);

    const pin = companyData.pincode ? `- ${companyData.pincode}` : "";

    return parts.length > 0 || pin
      ? `${parts.join(", ")} ${pin}`.trim()
      : "N/A";
  };

  const visibleFields = [...rowData]
    .filter((field) => !field.is_internal_field)
    .reverse();

  return (
    <div className="invoice-container">
      <h2 className="invoice-title" style={{ textAlign: "center" }}>
        {capitalizeFirstLetterOfEachWord(transactionName || "")}
      </h2>

      <div className="invoice-box">
        <div className="invoice-left">
          <div className="invoice-logo-container">
            <img
              src={organizationData.logo_url || ProfilePlaceholder}
              alt="Logo"
              className="invoice-logo-content"
            />
          </div>
          <div>
            <h3 className="invoice-company-name">
              {organizationData.name || "N/A"}
            </h3>
            <p className="invoice-company-address">
              {formatCompanyAddress(organizationData) || "N/A"}
              <br />
              GSTIN: {organizationData.gst_no || "N/A"}
              <br />
              State: {organizationData.state || "N/A"}
            </p>
          </div>
        </div>

        <div className="invoice-right">
          {purchaseDetails.map((item, index) => (
            <div
              key={index}
              className={`purchase-detail ${
                index === 0 ? "border-bottom" : ""
              }`}
            >
              <p className="detail-label">
                <strong>{item.label}:</strong>
              </p>
              <div className="detail-value">{item.value || "N/A"}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="invoice-supplier-details-container">
        <div className="invoice-supplier-section">
          <h4 className="invoice-section-title">Name of Supplier:</h4>
          <p className="invoice-section-text">
            <span style={{ fontSize: "14px", fontWeight: "bolder" }}>
              {companyData.company_name || "N/A"}
            </span>
            <br />
            Address: {companyData.company_address || "N/A"}
            <br />
            State: Karnataka
          </p>
        </div>

        <div className="invoice-delivery-section">
          <h4 className="invoice-section-title">Delivery at:</h4>
          <p className="invoice-section-text">
            <span style={{ fontSize: "14px", fontWeight: "bolder" }}>
              {companyData.company_name || "N/A"}
            </span>
            <br />
            Address: {companyData.company_address || "Address not specified"}
            <br />
            GSTIN: {companyData.company_gst_no || "N/A"}
            <br />
            State: Karnataka
          </p>
        </div>
      </div>

      <div className="invoice-overflow-x-scroll">
        <table className="invoice-table">
          <thead className="invoice-thead">
            <tr>
              <th className="invoice-th" style={{ borderLeftWidth: "0px" }}>
                No.
              </th>
              {visibleFields.map((field, index) => (
                <th
                  key={index}
                  className="invoice-th"
                  style={
                    index === visibleFields.length - 1
                      ? { borderRightWidth: "0px" }
                      : {}
                  }
                >
                  {field.title || field.field_name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {itemDetails.map((item, index) => (
              <tr key={index}>
                <td className="invoice-td" style={{ borderLeftWidth: "0px" }}>
                  {index + 1}
                </td>
                {[...rowData]
                  .filter((field) => !field.is_internal_field)
                  .reverse()
                  .map((field, idx, arr) => (
                    <td
                      key={idx}
                      className="invoice-td"
                      style={
                        idx === arr.length - 1
                          ? { borderRightWidth: "0px" }
                          : {}
                      }
                    >
                      {item[field.field_name] || "-"}
                    </td>
                  ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="invoice-grid-container no-top-border">
        <div className="invoice-left-pane note-pane">
          <div className="invoice-footer-signature-box">
            <p className="signature-note">
              <strong>Received the above material in good condition</strong>
            </p>
            <div className="signature-line"></div>
            <p className="signature-label">Receiver's Signature</p>
          </div>
        </div>

        <div className="invoice-right-pane">
          <div className="invoice-footer-signature-box">
            <p className="signature-note">
              <strong>For, {organizationData.name}</strong>
            </p>
            <div className="signature-line"></div>
            <p className="signature-label">Authorized Signature</p>
          </div>
        </div>
      </div>

      <p className="invoice-system-generated-note">
        This is a system-generated document and does not require a signature.
      </p>

      <div className="invoice-buttons" style={{ paddingTop: "40px" }}>
        <DownloadButton
          tableData={invoiceTableData}
          fileName="invoice"
          downloadFormats={["excel", "pdf", "full-page-pdf"]}
          fullPageDownload={true}
          fullPageSelector=".enquiry-page-container"
        />
      </div>
    </div>
  );
};
